import { __decorate } from "tslib";
import { AnyDecoder, ArrayDecoder, AutoEncoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@common/encoding';
import { NamedObject } from '../Event.js';
/**
 * A notification as seen by one user: the recipient row joined with its shared notification.
 * `type` and `subjectType` are decoded as plain strings so older clients keep working when new values are added.
 */
export class UserNotification extends AutoEncoder {
    /**
     * Id of the recipient row (uuidv7, sortable)
     */
    id;
    notificationId;
    type;
    organizationId = null;
    subjectType = null;
    subjectId = null;
    payload = {};
    groupKey = null;
    groupResourceCount = 0;
    /**
     * The most recently grouped resources (capped by the backend)
     */
    groupResources = [];
    /**
     * groupResourceCount at the time the user last read the notification
     */
    readCount = 0;
    readAt = null;
    seenAt = null;
    dismissedAt = null;
    createdAt;
    updatedAt;
}
__decorate([
    field({ decoder: StringDecoder })
], UserNotification.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UserNotification.prototype, "notificationId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UserNotification.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UserNotification.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UserNotification.prototype, "subjectType", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UserNotification.prototype, "subjectId", void 0);
__decorate([
    field({ decoder: AnyDecoder })
], UserNotification.prototype, "payload", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UserNotification.prototype, "groupKey", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], UserNotification.prototype, "groupResourceCount", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(NamedObject) })
], UserNotification.prototype, "groupResources", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], UserNotification.prototype, "readCount", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], UserNotification.prototype, "readAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], UserNotification.prototype, "seenAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], UserNotification.prototype, "dismissedAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], UserNotification.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], UserNotification.prototype, "updatedAt", void 0);
//# sourceMappingURL=UserNotification.js.map